import { getPaymentPurposesState } from './payment-purposes.selectors'
import ListTrait from 'src/app/traits/list.trait'
import {
  SetDefaultData,
  UpdateField,
  FetchPaymentPurposesRequest,
  DeletePaymentPurposeRequest,
} from './payment-purposes.actions'
import { Router, ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnChanges } from '@angular/core'
import { Subscription } from 'rxjs'
import { Map } from 'immutable'

@Component({
  selector: 'app-payment-purposes',
  templateUrl: './payment-purposes.component.html',
  styleUrls: ['./payment-purposes.component.css'],
})
export class PaymentPurposesComponent extends ListTrait implements OnInit {
  private state$: Subscription
  private route$: Subscription
  private shouldReload: boolean = false
  public isLoading: boolean = false
  public columns: object[] = [
    {
      prop: 'name',
      name: 'NAME',
      sortable: true,
    },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn',
    },
  ]

  constructor(
    private store: Store<any>,
    public router: Router,
    private route: ActivatedRoute,
  ) {
    super(router)
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('list'))
    this.state$ = this.store
      .pipe(select(getPaymentPurposesState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')

        if (
          state.get('shouldReload') != this.shouldReload &&
          state.get('shouldReload')
        ) {
          this.runFilter()
        }
        this.shouldReload = state.get('shouldReload')
      })

    this.route$ = this.route.queryParams.subscribe(this.runFilter.bind(this))
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.route$.unsubscribe()
  }

  runFilter(queryParams: any = {}) {
    const { page, page_size } = this.state.get('queryParams').toJS()
    const params = { page, page_size, ...queryParams }

    this.store.dispatch<any>(
      new FetchPaymentPurposesRequest({
        filters: params.keyword
          ? {
              or: [{ field: 'name', value: params.keyword }],
            }
          : {},
        pageSize: parseInt(params.page_size),
        page: parseInt(params.page) - 1,
        sort: {
          order: params.sort?.toUpperCase(),
          prop: params.order_by,
        },
      }),
    )

    this.store.dispatch(new UpdateField('queryParams', params, 'list'))
  }

  deletePaymentPurpose(id: number) {
    this.store.dispatch(new DeletePaymentPurposeRequest(id))
  }
}
